import { TupleStatus } from 'app/enum/tuple-status.enum';
import { MidStats } from 'app/model/mid-stats';
import { ModelWithoutId } from 'app/type';

import { makeBlankStore, Store } from './cris/store';
import { CrisRequest, makeCrisRequest } from './cris-request';
import { PublishDates } from './embeddable/publish-dates';
import { LabelTask } from './label-task';
import { Quantitative } from './quantitative';
import { RestfulModel } from './restful-model';
import { User } from './user';
import { SeamStatus } from '../constants/seam-status';

export interface SeamRequest extends RestfulModel, Quantitative {
    crisRequest: CrisRequest;
    store: Store;
    currentPlace: SeamStatus;
    dueDate?: string;
    owner?: User;
    manager?: User;
    tuner?: User;
    description: string;
    labelTasks: LabelTask[];
    correction: boolean;
    notes?: string;
    needsSync: boolean;
    initialStats: MidStats;
    diffStats: MidStats;
    statUpdatedAt: number;
    publishDates: PublishDates;
    patternTypes?: [];
    fScoreStat: { scoreBefore?: number; scoreAfter?: number };
    tupleStatus: TupleStatus;
}

export const makeBlankSeamRequest = <T extends Partial<SeamRequest>>(props?: T): ModelWithoutId<SeamRequest> & T => {
    const defaults: ModelWithoutId<SeamRequest> = {
        store: makeBlankStore({ id: 0, ...props?.store }),
        crisRequest: { ...makeCrisRequest(), id: '0' },
        currentPlace: SeamStatus.ASSIGN,
        description: '',
        completed: 0,
        total: 0,
        labelTasks: [],
        correction: true,
        needsSync: false,
        initialStats: { midCount: 0, trxCount: 0, totalSpend: '0.0' },
        diffStats: { midCount: 0, trxCount: 0, totalSpend: '0.0' },
        statUpdatedAt: 0,
        publishDates: {},
        patternTypes: [],
        fScoreStat: {},
        tupleStatus: TupleStatus.EMPTY,
    };

    return {
        ...defaults,
        ...props,
    } as ModelWithoutId<SeamRequest> & T;
};
